import React from 'react';
import styles from './CustomerNav.module.css';
import ScanQr from '../icons/ScanQR';
import { useHistory } from 'react-router-dom';
const DoormanNav = ({ isDisabled, id }) => {
  const history = useHistory();

  return (
    <div className={`${styles.menuNavCheck} position-fixed w-100`}>
      <div className='container'>
        <div className='row justify-content-center'>
          <div className={`col-12 col-md-7 col-lg-6 ${styles.customerNav}`}>
            <div className={`${styles.containerChecker}`}>
              <div
                onClick={() =>
                  !isDisabled &&
                  history.push({
                    pathname: `/scan-qr-checker/${id}`,
                    state: { id }, 
                  })
                }
              >
                <div
                  className={`${styles.circle} ${
                    isDisabled ? styles.outerCircleDenied : styles.outerCircle
                  }`}
                >
                  <div>
                    <ScanQr size='32px' color='#1d9bf0' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoormanNav;


